import store from 'js/lib/coursera.store';

export const DISMISSED_LOG_LOCALSTORAGE_KEY = 'peer-review-feedback-tips-dismissed';

export const getFeedbackModalId = (courseId: string, itemId: string) => {
  return `${courseId}~${itemId}`;
};

export const getDismissedFeedbackModals = () => {
  return store.get(DISMISSED_LOG_LOCALSTORAGE_KEY) || {};
};

export const dismissFeedbackModal = (courseId: string, itemId: string) => {
  const modalId = getFeedbackModalId(courseId, itemId);
  const dismissedFeedbackModals = getDismissedFeedbackModals();
  dismissedFeedbackModals[modalId] = true;
  store.set(DISMISSED_LOG_LOCALSTORAGE_KEY, dismissedFeedbackModals);
};

export const isFeedbackModalDismissed = (courseId: string, itemId: string) => {
  const modalId = getFeedbackModalId(courseId, itemId);
  const dismissedFeedbackModals = getDismissedFeedbackModals();
  return !!dismissedFeedbackModals[modalId];
};
